<template>
    <div class="three-main-posts mt-4">
        <b-row>
            <b-col cols="12" sm="6" md="3" v-for="post in threeMainPosts" :key="post.id" class="main-post">
                 <b-link :to="'/' + post.category + '/' + post.id">
                    <b-row>
                        <b-col cols="4"  sm="12">
                            <b-card-img :src="post.imgUrl" :alt="post.title"></b-card-img>
                        </b-col>
                        <b-col cols="8"  sm="12" class="post-content">
                            <b-card-body>
                                <b-card-title style="textTransform: capitalize">{{post.title}}</b-card-title>
                                <b-card-text v-html="post.body.split(' ').slice(0, 15).join(' ')+ '...'"></b-card-text>
                                <div class="author-date">
                                    <ul>
                                        <li>
                                            <strong>{{post.author}}</strong>
                                        </li>
                                    </ul>
                                </div>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-link>
                <hr>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { getFourLatestPostsByCategory } from '../../firebase/posts'
export default {
    props: ['category'],
    data() {
        return {
            threeMainPosts: []
        }
    },
    created() {
        getFourLatestPostsByCategory(this.category).then((posts) => {
            this.threeMainPosts = posts
        })
    }
}
</script>

<style scoped lang="scss">
    @import '../../styles/components/home/MainPostsByCat.scss'
</style>


